import Reveal from "@/components/base/Reveal";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  dark?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  dark = false,
}: SectionHeadingProps) {
  const alignClass =
    align === "center" ? "text-center mx-auto" : "text-left";

  return (
    <Reveal className={`max-w-3xl ${alignClass}`}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-semibold tracking-widest uppercase mb-5 ${
            dark
              ? "bg-primary-500/15 text-primary-300"
              : "bg-primary-100 text-primary-700"
          }`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
          {eyebrow}
        </span>
      )}
      <h2
        className={`text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight ${
          dark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-5 text-base md:text-lg leading-relaxed ${
            dark ? "text-background-300" : "text-foreground-600"
          }`}
        >
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}